import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { UseCases } from "@planzone/core";
import { zoneProjectsRetrievalFilter } from "@planzone/dto";
import { useZoneProjectsRetrieval } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { ZoneAvatar } from "@common/zoneAvatar";
import { FolderIcon } from "@common/folderIcon";
import { ActivityWatcher } from "@common/activityWatcher";
import { SecureContextualMenu } from "@common/secureContextualMenu";
import { AverageWeather } from "./averageWeather";
import { Props } from "./types";
import styles from "./styles.scss";
import { WeatherReport } from "@common/weatherReport";

function Zone({ zone }: Props) {
  const { t } = useTranslation();
  const push = useNavigate();
  const { pushView } = useModal();
  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  ActivityWatcher.useActivityWatcher(ref, {
    focus: () => setShowContextualMenu(!showContextualMenu),
    blur: () => setShowContextualMenu(false),
  });

  return (
    <div className={styles.zone}>
      <div
        className={styles.header}
        onClick={() => push(`/zones/${zone.uuid}`)}
      >
        <div className={styles.zoneAvatar}>
          <ZoneAvatar name={zone.name} color={zone.color} />
        </div>
        <h3 className={styles.name}>{zone.name}</h3>
      </div>
      <div className={styles.projects}>
        <div className={styles.projectsNumberBox}>
          <FolderIcon className={styles.folderIcon} />
          <p className={styles.projectNbr}>
            {zone.totalNumberOfProjectsInZone}
          </p>
        </div>
      </div>
      <div className={styles.weather}>
        {zone.totalNumberOfProjectsInZone > 0 ? (
          <AverageWeather weather={zone.weather} />
        ) : (
          <div className={styles.empty} />
        )}
      </div>
      <div
        className={classNames(styles.contextualMenu, {
          [styles.displayContextualMenu]: showContextualMenu,
        })}
      >
        <div ref={ref}>
          <SecureContextualMenu
            items={[
              {
                name: t("zonesPage.zones.edit"),
                useCase: UseCases.editZone,
                act: () =>
                  pushView({
                    key: UseCases.editZone,
                    data: zone,
                  }),
              },
              {
                name: t("zonesPage.zones.remove"),
                useCase: UseCases.removeZone,
                color: "#df3b37",
                act: () =>
                  pushView({
                    key: UseCases.removeZone,
                    data: zone,
                  }),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export { Zone };
